import { ButtonLink } from '@/components/ui/ButtonLink';
import { Container } from '@/components/ui/Container';
import { Label } from '@/components/ui/Label';
import { site } from '@/content/site';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

export function NotFoundPage() {
  useDocumentMeta({
    title: `Page introuvable, ${site.name}`,
    description: 'Cette adresse ne correspond à aucune page du site.',
    path: '/404',
  });

  return (
    <section className="py-24">
      <Container className="flex min-h-[50vh] flex-col justify-center">
        <Label>Erreur 404</Label>
        <h1 className="mt-5.5 text-title">Cette page n&apos;existe pas.</h1>
        <p className="mt-4.5 max-w-[40em] text-sub text-encre-soft">
          L&apos;adresse demandée ne correspond à aucune page du site. Reprenez depuis
          l&apos;accueil, ou parcourez le blog.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <ButtonLink to="/">Retour à l&apos;accueil</ButtonLink>
          <ButtonLink to="/blog" variant="ligne">
            Lire le blog
          </ButtonLink>
        </div>
      </Container>
    </section>
  );
}
